import { render } from "./AccountProfile.vue?vue&type=template&id=081a7aca&scoped=true"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"

import "./AccountProfile.vue?vue&type=style&index=0&id=081a7aca&scoped=true&lang=css"
import "./AccountProfile.vue?vue&type=style&index=1&id=081a7aca&lang=css"
script.render = render
script.__scopeId = "data-v-081a7aca"

export default script